// Central content file — easy for the business owner to edit.
// Swap image URLs here to replace photos site-wide without redesigning.

export const BRAND = {
  name: "Taste of Platinum",
  tagline: "Island Flavor. Platinum Experience.",
  email: "TasteofPlatinum@gmail.com",
  instagram: "theplatinumgrill",
  instagramUrl: "https://instagram.com/theplatinumgrill",
  serviceArea: "Atlanta Metro & Surrounding Areas",
  logo: "/uploads/logo-badge.jpeg",
  logoFull: "/uploads/logo.jpeg",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1610057098265-05f2bcbedd55?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  jerkTray: "https://images.unsplash.com/photo-1632852576480-c10a8e19496a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  curryPlate: "https://images.unsplash.com/photo-1665332561290-cc6757172890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  oxtail: "https://images.unsplash.com/photo-1608500218861-01091cdc501e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  oxtail2: "https://images.unsplash.com/photo-1719132125606-b9a713fbb496?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  grill: "https://images.unsplash.com/photo-1592415162645-c055a337b613?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  jerkPlatter: "/uploads/jerk-platter.jpeg",
  beefPatty: "/uploads/beef-patty.jpeg",
  brownStewChicken: "/uploads/brown-stew-chicken.jpeg",
  rastaPasta: "/uploads/rasta-pasta.jpeg",
  oxtailPlate: "/uploads/oxtail-plate.jpeg",
  entreeOxtailDinner: "/uploads/entree-oxtail-dinner.jpeg",
  entreeJerkChicken: "/uploads/entree-jerk-chicken.jpeg",
  dessertRumCake: "/uploads/dessert-rum-cake.jpeg",
  dessertPotatoPudding: "/uploads/dessert-potato-pudding.jpeg",
  riceAndPeas: "/uploads/rice-and-peas.jpeg",
  servicesFeatured: "/uploads/services-featured.jpeg",
  chefJuliet: "/uploads/juliet.png",
  catering1: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  catering2: "https://images.unsplash.com/photo-1616668856493-9df876327739?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  catering3: "https://images.unsplash.com/photo-1564638305579-5e395c9b62c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  patties: "https://images.pexels.com/photos/27556962/pexels-photo-27556962.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  plantains: "https://images.unsplash.com/photo-1540714605746-4f474eefc6d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  festival: "https://images.unsplash.com/photo-1543738066-49621e5b1f87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dessertCake: "https://images.unsplash.com/photo-1611497406092-4bc22c54b322?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dessertSlice: "https://images.unsplash.com/photo-1522336849566-02cbb8bffc4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mealPrep1: "https://images.unsplash.com/photo-1543352632-5a4b24e4d2a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mealPrep2: "https://images.unsplash.com/photo-1667499745120-f9bcef8f584e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dining1: "https://images.unsplash.com/photo-1777915392856-e1e5c46de326?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dining2: "https://images.unsplash.com/photo-1785960862202-169ad89e3469?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dining3: "https://images.unsplash.com/photo-1751891076198-f1162574c39c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};


export const SERVICES = [
  { key: "catering", title: "Catering", tag: "Celebrations & Corporate",
    desc: "Birthdays, baby & bridal showers, graduations, plus corporate lunches, office gatherings, and employee & client appreciation events." },
  { key: "mealprep", title: "Meal Prep", tag: "Weekly & Chef-Crafted",
    desc: "Convenient, delicious Jamaican-inspired meals prepared to help make your week easier." },
  { key: "privatechef", title: "Private Chef", tag: "Intimate & Exclusive",
    desc: "Personalized culinary experiences for intimate dinners and special occasions." },
  { key: "events", title: "Special Events", tag: "Weddings & More",
    desc: "Weddings, rehearsal & engagement dinners, anniversaries and milestone celebrations, formal dinners, family reunions, holiday gatherings, and memorials or repasts." },
];

export const SERVICE_DETAILS = [
  { key: "dropoff", title: "Drop-Off Catering", image: IMAGES.catering1,
    intro: "Flavorful, ready-to-serve spreads delivered to your event.",
    list: ["Corporate events", "Family gatherings", "Parties", "Celebrations", "Meetings", "Community events"] },
  { key: "privatechef", title: "Private Chef Experiences", image: IMAGES.dining1,
    intro: "Customized culinary experiences in the comfort of your space.",
    list: ["Private dinners", "Date nights", "Anniversaries", "Small gatherings", "Celebrations", "Special occasions"] },
  { key: "appetizers", title: "Appetizers & Small Bites", image: IMAGES.patties,
    intro: "Elevated bites perfect for mingling and receptions.",
    list: ["Cocktail events", "Receptions", "Corporate gatherings", "Parties", "Celebrations"] },
  { key: "desserts", title: "Jamaican Desserts", image: IMAGES.dessertCake,
    intro: "Jamaican-inspired desserts and specialty sweets to finish in style.",
    list: ["Rum cake", "Sweet potato pudding", "Coconut drops", "Specialty desserts"] },
];

export const EVENTS = [
  "Weddings", "Birthdays", "Baby Showers", "Bridal Showers", "Graduations",
  "Corporate Events", "Memorials", "Repasts", "Private Dinners", "Family Reunions",
  "Holiday Parties", "Celebrations", "Community Events", "And More",
];

export const WHY_US = [
  { title: "Authentic Flavor", desc: "A genuine passion for bold, authentic Jamaican-inspired taste." },
  { title: "Customized Menus", desc: "Every menu is tailored around what you and your guests love." },
  { title: "Freshly Prepared", desc: "Food prepared with care, never mass-produced." },
  { title: "Professional Service", desc: "Polished, reliable service from first inquiry to fulfillment." },
  { title: "Flexible Options", desc: "Delivery, pickup, plated, drop-off — built around you." },
  { title: "Events of All Sizes", desc: "From intimate dinners to large celebrations." },
];

export const EVENT_TYPES = [
  "Wedding", "Birthday", "Baby Shower", "Bridal Shower", "Graduation",
  "Corporate Event", "Memorial", "Repast", "Private Dinner", "Family Reunion",
  "Holiday Party", "Other",
];

export const SERVICE_OPTIONS = [
  "Drop-Off Catering", "Plated Meals", "Private Chef", "Appetizers", "Desserts", "Meal Prep", "Custom Request",
];

export const BUDGETS = [
  "Under $500", "$500–$1,000", "$1,000–$2,500", "$2,500–$5,000", "$5,000+", "Prefer to Discuss",
];

export const FAQS = [
  { q: "Do you serve the Atlanta area?", a: "Yes. Taste of Platinum serves Atlanta Metro and surrounding areas. Service availability may vary depending on the event location." },
  { q: "Do you have a physical restaurant location?", a: "Taste of Platinum provides catering, meal preparation, and private food services throughout the Atlanta Metro area." },
  { q: "How far in advance should I book catering?", a: "We encourage you to submit your request as early as possible, especially for large events and popular dates, so we can best accommodate you." },
  { q: "Do you offer custom menus?", a: "Yes. You're encouraged to share all the dishes you're interested in so we can provide the most accurate quote and menu recommendations." },
  { q: "What events do you cater?", a: "Weddings, birthdays, baby showers, bridal showers, graduations, corporate events, memorials, repasts, private dinners, family reunions, holiday parties, celebrations, community events, and more." },
  { q: "Do you offer delivery?", a: "Yes, delivery availability depends on location and service type. Final delivery details and fees are confirmed during the booking process." },
  { q: "How does meal prep work?", a: "1) Select a package. 2) Select meals. 3) Submit your order request. 4) Receive an Order ID confirming your request was received. 5) Your order is reviewed. 6) Final details and pricing are confirmed. 7) An invoice/payment request is sent. 8) Payment requirements are satisfied. 9) Your order is confirmed. 10) You receive delivery or pickup details." },
  { q: "When is the meal prep deadline?", a: "Orders must be submitted by Thursday at 11:59 PM for the upcoming fulfillment cycle." },
  { q: "When are meal prep orders available?", a: "Sunday and Monday." },
  { q: "Can I request dishes not listed?", a: "Yes. Simply include any requested dishes in your inquiry or order request." },
  { q: "How do I pay?", a: "After your order has been reviewed and final details are confirmed, you'll receive applicable payment instructions or a secure digital invoice." },
];

export const GALLERY = [
  { category: "Entrées", image: IMAGES.jerkTray },
  { category: "Entrées", image: IMAGES.entreeOxtailDinner },
  { category: "Entrées", image: IMAGES.entreeJerkChicken },
  { category: "Catering", image: IMAGES.catering1 },
  { category: "Catering", image: IMAGES.catering2 },
  { category: "Catering", image: IMAGES.catering3 },
  { category: "Events", image: IMAGES.dining3 },
  { category: "Meal Prep", image: IMAGES.mealPrep1 },
  { category: "Meal Prep", image: IMAGES.mealPrep2 },
  { category: "Appetizers", image: IMAGES.patties },
  { category: "Appetizers", image: IMAGES.plantains },
  { category: "Desserts", image: IMAGES.dessertCake },
  { category: "Desserts", image: IMAGES.dessertRumCake },
  { category: "Desserts", image: IMAGES.dessertPotatoPudding },
  { category: "Entrées", image: IMAGES.oxtail2 },
];

export const GALLERY_CATEGORIES = [
  "All", "Entrées", "Catering", "Events", "Meal Prep", "Appetizers", "Desserts",
];
